module.exports = __webpack_public_path__ + "static/img/applicableScene6.4e59e07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene6.png
// module id = Sb/D
// module chunks = 0